import styled from '@emotion/styled'
import React from 'react'
import {PALETTE} from '../styles/paletteV3'

import IconButton from './IconButton'

const StyledButton = styled(IconButton)({
  height: 24,
  padding: 0,
  ':hover,:focus,:active': {
    color: PALETTE.SLATE_600
  }
})



const SidebarToggle = (props) => {
  const {dataCy} = props
  return (
    React.createElement(StyledButton, {
      ...props,
      dataCy: `${dataCy}-toggle`,
      'aria-label': "Toggle the sidebar"  ,
      icon: "menu",
      iconLarge: true,
      palette: "midGray",}
    )
  )
}
export default SidebarToggle
